// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal .van-field__label{text-align:left;flex:1}.deal .van-dialog__message{font-size:14px}.deal ::-webkit-input-placeholder{color:red}.deal :-moz-placeholder,.deal ::-moz-placeholder{color:red}.deal :-ms-input-placeholder{color:red}", ""]);
// Exports
module.exports = exports;
